module.exports = __webpack_public_path__ + "img/3_57.31633d8a.png";